export default {
  title: 'Danh sách request tìm kiếm của F2',
  columns: {
    no: 'STT',
    agentCode: 'Đại lý',
    flightDates: 'Ngày bay',
    // request: 'Request',
    requestType: 'Loại request',
    routes: 'Hành trình',
    trips: 'Chi tiết',
    createdAt: 'Thời gian',
    source: 'HT đặt vé',
  },
  requestType: {
    SEARCH: 'Tìm kiếm',
    PAYMENT: 'Thanh toán',
    CREATE: 'Đặt chỗ',
  },
  filters: {
    startDate: 'Từ ngày',
    endDate: 'Đến ngày',
    agencyCode: 'Đại lý',
    requestType: 'Loại request',
    searchText: 'Tìm kiếm',
    ph: {
      searchText: 'Nhập và nhấn ↵ để tìm kiếm',
    },
  },
  connectingFlight: 'Nối chuyến',
  ADULT: 'Người lớn',
  CHILD: 'Trẻ em',
  INFANT: 'Trẻ Sơ sinh',
  directFlight: 'Bay thẳng',
  combine: 'Kết hợp',
  splitSegment: 'Tách chặng',
  price: 'Giá',
  updateSuccess: 'Cập nhật {lastName} {firstName} thành công',
  confirmDelete: 'XÁC NHẬN XÓA',
  confirmDeleteBankAccount: 'Are you sure you want to delete this bank account?',
  confirm: 'Confirm',
  cancel: 'Cancel',
  cannotDeleteDefaultAccount: 'Không thể xóa tài khoản mặc định!',
}
